import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import React from "react";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { faCalendarLines } from "@fortawesome/pro-duotone-svg-icons";
import { Convite } from "../../../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Convite";
import { Evento } from "../../../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Evento";
import { capitalize } from "../../../../utils/Capitalize";
import { sxDivider } from "./sxProps";
import InfoLabel from "./InfoLabel";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";

interface InvitationCardProps {
  invitation: Convite;
  onConfirm: () => void;
  onCancel: () => void;
}

export const InvitationCard: React.FC<InvitationCardProps> = ({ invitation, onConfirm, onCancel }) => {
  const evento = invitation?.evento
  const accessibility = useAccessibility();

  const getStatusColor = (evento: Evento) => {
    if (evento?.descrStatus === null) {
      return evento?.dtConfirmacao ? "#00995D" : "#F47920";
    }

    switch (evento?.descrStatus) {
      case "NÃO VOU":
        return "error";
      default:
        return "#00995D";
    }
  };

  const getStatusDescricao = (evento: Evento) => {
    if (evento?.descrStatus === null) {
      return evento?.dtConfirmacao ? "Aceitou" : "Novo!";
    }

    switch (evento?.descrStatus) {
      case "NÃO VOU":
        return "NÃO VOU";
    }
  };

  const nomePrestador = invitation?.nomePrestador && capitalize(invitation?.nomePrestador);
  const dataHora = [evento?.data, evento?.hora].filter(Boolean).join(" ") || "-";
  const addressValue = invitation?.evento?.complementos?.find(c => c.codigo === 'ENDER')?.valor;
  const address = addressValue ? capitalize(addressValue) : addressValue;

  return (
    <div>
      <div className="invitation-card" tabIndex={0} style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
        <div className="palestra-card-icon-holder">
          <FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={faCalendarLines} className="fadt-file-contract" />
        </div>
        <div className="invitation-card-content">
          <InfoLabel label="Convite enviado por:" value={nomePrestador} />
          <InfoLabel label="Tema dos Eventos e Palestras:" value={evento?.tema ?? '-'} />
          <InfoLabel label="Descrição" value={evento?.descr} />
          <Divider sx={sxDivider} />

          <InfoLabel label="Data e hora do evento:" value={dataHora ?? '-'} />
          {evento?.tipoEvento === "P" && address && (
            <InfoLabel label="Endereço" value={address ?? '-'} />
          )}
          <InfoLabel label="Tipo:" value={evento?.descrTipoEvento ?? '-'} />
          <InfoLabel label="Status:" value={
            <Typography style={accessibility.textStyleAccessibility} color={getStatusColor(evento)}>
              <b>{getStatusDescricao(evento)}&nbsp;</b>
            </Typography>} />
          <div className="invitation-card-actions">
            <DefaultButton text="Tenho interesse" variant="contained" onClick={onConfirm} />
            <DefaultButton text="Não tenho interesse" variant="outlined" onClick={onCancel}/>
          </div>
        </div>
      </div>
    </div>
  );
};